"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    checkConfig: function() {
        return checkConfig;
    },
    checkLibraryConfig: function() {
        return checkLibraryConfig;
    }
});
var _logger = require("./logger");
var checkConfig = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var headerDataProvider = config.headerDataProvider, debug = config.debug;
    var logger = (0, _logger.getLogger)(debug);
    if (!headerDataProvider || typeof headerDataProvider !== "function" || headerDataProvider.length < 1) {
        logger.error("TrackingV3 - 'config.headerDataProvider' does not meet the expected requirements: should be a function with one argument (a callback)");
        return false;
    }
    return true;
};
var checkLibraryConfig = function() {
    var config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var locale = config.locale, didomiNoticeId = config.didomiNoticeId, rudderstackJsKey = config.rudderstackJsKey, rudderstackDataPlaneURL = config.rudderstackDataPlaneURL, privacyPolicyURL = config.privacyPolicyURL;
    var logger = (0, _logger.getLogger)(true);
    if (!locale) {
        logger.error("TrackingV3 - 'config.locale' is required");
        return false;
    }
    if (!didomiNoticeId) {
        logger.error("TrackingV3 - 'config.didomiNoticeId' is required");
        return false;
    }
    if (!rudderstackJsKey) {
        logger.error("TrackingV3 - 'config.rudderstackJsKey' is required");
        return false;
    }
    if (!rudderstackDataPlaneURL) {
        logger.error("TrackingV3 - 'config.rudderstackDataPlaneURL' is required");
        return false;
    }
    if (!privacyPolicyURL) {
        logger.error("TrackingV3 - 'config.privacyPolicyURL' is required");
        return false;
    }
    return true;
};

//# sourceMappingURL=checkConfig.js.map